import { mainSiteUrl } from '@/mocks/categories';

export default function TestimonialSection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <div className="relative rounded-3xl bg-foreground-950 overflow-visible">
        <div className="flex flex-col lg:flex-row">
          <div className="w-full lg:w-[42%] relative">
            <div className="lg:absolute lg:-left-8 lg:top-1/2 lg:-translate-y-1/2 h-80 lg:h-[420px] w-full lg:w-[110%]">
              <img
                src="https://readdy.ai/api/search-image?query=Confident%20modern%20entrepreneur%20in%20casual%20blazer%20standing%20in%20bright%20airy%20loft%20office%20with%20exposed%20brick%20wall%20and%20plants%20warm%20natural%20window%20lighting%20genuine%20smile%20professional%20yet%20approachable%20mood%20editorial%20portrait%20photography%20clean%20contemporary%20aesthetic&width=800&height=1100&seq=testimonial-v4&orientation=portrait"
                alt="itaobuyspreadsheet user testimonial"
                title="itaobuyspreadsheet - User Success Story"
                className="w-full h-full object-cover object-top rounded-2xl lg:rounded-3xl"
              />
            </div>
          </div>

          <div className="w-full lg:w-[58%] px-6 md:px-12 py-12 md:py-16 lg:py-20 flex flex-col justify-center">
            <div className="text-7xl md:text-8xl font-heading text-accent-500 leading-none mb-4">&ldquo;</div>
            <blockquote className="text-base md:text-lg text-background-100 leading-relaxed mb-6">
              itaobuyspreadsheet completely transformed how I source products from China. Before discovering this tool, I spent hours manually searching Taobao listings. Now I can compare verified suppliers in minutes and confidently place orders knowing the data has been vetted. My sourcing costs dropped by nearly 50% in the first month.
            </blockquote>
            <div>
              <p className="text-sm font-semibold text-background-50">Marcus Chen</p>
              <p className="text-xs text-foreground-400 mt-0.5">Amazon FBA Seller & Reseller</p>
            </div>
            <div className="mt-8">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-foreground-950 rounded-full text-sm font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                Try itaobuyspreadsheet
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-base"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}